import { Reducer } from 'redux'
import { ServiceActionTypes, ServiceState } from './type'

const initialState: ServiceState = {
  serviceCard: {},
  selectPolicy: {},
  userRealAuthInfo: {}
}

//cardNo服务卡改为c端可以直接申请，用policyNo_vasCode作为申请填写数据的唯一标识
//c端调用addServiceCard获取cardNo保存到对象中，上传附件以及提交时统一使用对象中的cardNo
const reducer: Reducer<ServiceState> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceActionTypes.EDIT_SERVICE: {
      const { key, value, cardNo, params = {} } = action;
      return {
        ...state,
        serviceCard: {
          ...state.serviceCard,
          [cardNo]: {
            ...state.serviceCard[cardNo],
            [key]: value,
            ...params
          }
        }
      }
    }
    case ServiceActionTypes.UPLOAD_FILE_SUCCESS: {
      const { data, cardNo } = action;
      console.log(action);
      return {
        ...state,
        serviceCard: {
          ...state.serviceCard,
          [cardNo]: {
            ...state.serviceCard[cardNo],
            attachmentList: [
              ...state.serviceCard[cardNo].attachmentList || [],
              data
            ]
          }
        }
      }
    }
    case ServiceActionTypes.DELETE_FILE: {
      const { cardNo, id } = action;
      return {
        ...state,
        serviceCard: {
          ...state.serviceCard,
          [cardNo]: {
            ...state.serviceCard[cardNo],
            attachmentList: [
              ...state.serviceCard[cardNo].attachmentList.filter(i => i.id !== id)
            ]
          }
        }
      }
    }
    case ServiceActionTypes.CLEAR_SERVICE: {
      const { cardNo } = action;
      return {
        ...state,
        serviceCard: {
          ...state.serviceCard,
          [cardNo]: {}
        }, 
        selectPolicy: {},
      }
    }
    case ServiceActionTypes.SELECT_POLICY: {
      const { data = {} } = action;
      return {
        ...state,
        selectPolicy: data,
      }
    }
    case ServiceActionTypes.FETCH_USER_REALAUTH_INFO_SUCCESS: {
      const { data = {} } = action;
      return {
        ...state,
        userRealAuthInfo: data,
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as ServiceReducer };